import {DxGridDataType} from "../dx-grid-data-type";
import {DxGridFilterOperationType} from "./dx-grid-filter-operation-type";
import {DxNciDictionary} from "../../../dx-nci-core/domain/dx-nci-dictionary";


/**
 * Фильтр для колонок грида.
 * Использование сериализации \ десериализации нужно для возможности задания
 * дефолтной фильтрации через опции.
 */
export class DxGridFilter {
  /**
   * Тип логичекой операции: contains, !contains, =, !=, <, > и тд.
   * @name _operation
   * @type {DxGridFilterOperationType}
   */
  private readonly _operation: DxGridFilterOperationType;

  /**
   * Тип данных значений фильтра.
   * Так как массив значений фильтра полиморфен, то надо задавать тип.
   * По-факту это тип данных колонки для которой назначен фильтр.
   * @name _dataType
   * @type {DxGridDataType}
   */
  private readonly _dataType: DxGridDataType;

  /**
   * Массив значений (заточка на множественную отметку).
   * Строка - потому-что TypedJSON не понимает что такое any
   * @name _values
   * @type {string[]}
   */
  private readonly _values: string[];

  /**
   * Ссылка на справочник если фильтруется колонка с типом данных справочника.
   * По-идее, это надо только для эмуляции серверных операций пока нет бэка.
   * @name _dictionary
   * @type {DxNciDictionary}
   */
  private readonly _dictionary: DxNciDictionary;


  constructor(dataType: DxGridDataType,
              operation: DxGridFilterOperationType,
              values: any[],
              dictionary?: DxNciDictionary) {
    this._operation = operation;
    this._dataType = dataType;
    this._values = values;
    this._dictionary = dictionary;
  }


  /** Проверяет, удовлетворяет ли переданное значение данному фильтру. */
  public passValue(value: any): boolean {
    if(!this._values || this._values.length === 0) return true;
    let pass = false;
    switch (this._operation) {
      case DxGridFilterOperationType.CONTAINS:
        pass = this._contains(value);
        break;
      case DxGridFilterOperationType.EQUALS:
        pass = this._equals(value);
        break;
      default:
        break;
    }
    return pass;
  }


  private _contains(value: any): boolean {
    let contains = false;
    // TODO: При реализации фильтра-выпадайки для колонок-справочников уйдет в аналы
    // TODO: фильтрация справочников по условию contains. Убрать это!!!
    if(DxGridDataType.DICTIONARY === this._dataType) {
      if(this._dictionary.elementIndex.has(value)) {
        const dictElem = this._dictionary.elementIndex.get(value);
        this._values.forEach(filterVal => {
          if(dictElem.name.includes(filterVal)) {
            contains = true
          } else if(filterVal.includes(dictElem.name)) {
            contains = true
          }
        });
      } else {
        contains = this._containsAsString(value.toString());
      }
    } else {
      contains = this._containsAsString(value.toString());
    }
    return contains;
  }


  private _containsAsString(value: string): boolean {

    value = value.toLowerCase();

    return !!this._values.map(val => val.toLowerCase())
                         .find(filterVal => value.includes(filterVal));
  }


  private _equals(value: any): boolean {
    let pass = false;
    if(DxGridDataType.DICTIONARY === this._dataType) {
      // TODO: Вся эта возня со справочниками нужна из-за того что не:
      // TODO: 1. Не реализована серверная фитрация данных
      // TODO: 2. Не реализован фильтр-выпадайка с чекбоксами для колонок-справочников
      // TODO: Элементы справочников должны сопоставляться по их id
      // TODO: Убрать это при доработке этих пунктов.
      if(this._dictionary.elementIndex.has(value)) {
        const dictElem = this._dictionary.elementIndex.get(value);
        this._values.forEach(filterVal => {
          if(dictElem.name == filterVal) {
            pass = true
          }
        });
      } else {
        pass = this._equalsAsString(value);
      }
    } else {
      pass = this._equalsAsString(value);
    }
    return pass;
  }


  private _equalsAsString(value: string): boolean {
    let equals: boolean = false;
    this._values.forEach(filterVal => {
      if(filterVal === value) {
        equals = true;
      }
    });
    return equals;
  }


  get values(): any[] {
    return this._values;
  }

  get operation(): DxGridFilterOperationType {
    return this._operation;
  }
}
